export const lang_hr = {
    appBar: {
        pdf_tooltip: "Preuzmi PDF upute",
        video_tooltip: "Otvori video upute"
    },
    appModalTitle: "Greška",
    btnCancel: "Odustani",
    btnClose: "Zatvori",
    btnSave: "Spremi",
    common: {
        dateFrom: "Datum od",
        dateTo: "Datum do",
        dialog_cancel_btn: "Odustani",
        dialog_ok_btn: "OK",
        dialog_title: "Potvrda",
        progress_bar_text: "Molim pričekajte...",
        remark: "Napomena",
        contact: "Kontakt"
    },
    digital_certificates: {
        no_data: "Nema seminara za koje možete preuzeti digitalnu svjedodžbu",
        instructions_popup: "Za preuzimanje digitalne svjedodžbe potrebno je omogućiti popup prozore.",
        subtitle: "Preuzmite certifikat klikom na redak"
    },
    documents: {
        download: {
            or_more: "(ili više)",
            number_of_files: "broj materijala koji se mogu preuzeti",
            zero_files: "nema dodatnih materijala za preuzimanje",
            file_does_not_exist: "Datoteka ne postoji",
            file_exists: "Datoteka postoji",
            additional_documents: "Dodatni materijali",
            additional_documents_not_found: "Nisu pronađeni dodatni materijali za ovu uslugu",
            additional_documents_modal_title: "Dodatni materijali za: {education}",
            download_success: "Preuzimanje završeno",
            no_documents: "Nema dokumenata",
            seminar_download: "Preuzimanje seminarskog zadatka",
            seminar_download_not_found: "Nije pronađen seminarski zadatak za ovu uslugu",
            tooltip: "Za preuzimanje kliknite na redak",
            tooltip_show: "Za prikaz dodatnih dokumenata kliknite na redak",
            digital_manuals: "Digitalni priručnici"
        },
        upload: {
            available_services: "Dostupne usluge",
            enrollment_expired: "Upis istekao",
            file_not_selected: "Morate odabrati uslugu iz padajućeg izbornika i datoteku",
            file_upload_label: "Odaberite datoteku",
            program_not_selected: "Morate odabrati uslugu",
            less_then_limit_title: "Slanje rješenja do maksimalno {n} MB",
            more_then_limit_title: "Slanje rješenja većeg od {n} MB",
            more_then_limitA: "1. Ukoliko je vaš seminarski rad dostupan na Internetu (npr. web site ili aplikacija), ovdje umjesto seminarskog rada, predajte .txt datoteku (Notepad)",
            more_then_limitB: "2. U istu upišite link za pristup seminarskom radu.",
            more_then_limitC: "3. Ako je za pristup seminarskom radu potrebno još podataka, npr. korisničko ime i lozinka, i njih upišite u istu .txt datoteku.",
            more_then_limit2_1: "1. Ako je vaš seminarski rad veći od {n} MB, a nije dostupan na Internetu, obavezno ga arhivirajte u jednu ZIP ili RAR datoteku i postavite na neki od fileshare servisa navedenih u nastavku.",
            more_then_limit2_2: "2. Ovdje, umjesto seminarskog rada, predajte .txt datoteku u koju upišite link za download seminarskog rada.",
            more_then_limit2_3: "3. Ako je za download ili otvaranje arhive potreban još neki podatak, npr. korisničko ime i lozinka, i njih upišite u istu .txt datoteku (Notepad).",
            more_then_limit2_40: "",
            more_then_limit2_41: "Besplatni fileshare servisi koje možete koristiti:",
            seminar_instruction1_1: "1. Vaš seminarski zadatak će biti ispravljen kroz najviše 30 dana od dana predaje.",
            seminar_instruction1_2: "2. Na ovom mjestu možete saznati je li Vaš rad zadovoljio, a ukoliko je Vaša mail adresa evidentirana u našem sustavu, dobit ćete i e-mail obavijest.",
            seminar_instruction2_1: "3. Seminarski zadatak koji preuzimate je u PDF obliku unutar kompresirane datoteke.",
            seminar_instruction2_2: "4. Kako biste mogli otvoriti Vaš zadatak potrebno je imati PDF reader te program za dekompresiju.",
            title_available_internet: "Dostupno na internetu:",
            title_unavailable_internet: "Nedostupno na internetu:",
            title_instructions: "Ostale upute",
            upload: "Predaj seminarski zadatak",
            upload_email_error: "Rješenje uspješno poslano, ali mentor nije obaviješten",
            upload_error: "Seminar nije poslan, greška pri spremanju podataka",
            upload_success: "Slanje uspješno"
        },
        history: {
            title: "Povijesni pregled statusa (odaberite uslugu iz gornjeg padajućeg izbornika)",
            status_name_1: "Preuzet",
            status_name_2: "Zaprimljen",
            status_name_3: "Pregledan - NEISPRAVAN",
            status_name_4: "Pregledan - ISPRAVAN",
            table_header_date: "Datum promjene statusa",
            table_header_status: "Status",
            table_header_comment: "Komentar",
            table_header_mentor: "Mentor"
        }
    },
    ev_lista: {
        table_view_headers: {
            event_date: "Datum",
            event_name: "Ime",
            event_lecturer: "Predavač",
            event_presence: "Prisutnost",
            event_status: "Status"
        },
        exam_result: {
            _1: "Položeno",
            _2: "Pad",
            _3: "Nije pristupio",
            _4: "Čeka evaluaciju rezultata",
            _5: ""
        },
        my_q_test_results_link_title: "Prikaži rezultate svih mojih ispita"
    },
    exam_register: {
        address: 'Adresa',
        classroom: 'Učionica',
        city: "Grad",
        city_not_selected: "Nije odabran grad",
        confirm_button: "Želim prijaviti ispit",
        confirm_registration: "Želite prijaviti ispit za: {name} u terminu: {date_time} te potrošiti jedan kredit?",
        credits_state: "Status kredita",
        credits_overall: "Ukupno",
        credits_available: "Na raspolaganju",
        credits_used: "Potrošeno",
        exam_succesfully_registered: "Ispit uspješno prijavljen",
        exam_term_register_notice1: "Krajnji vremenski rok za prijavu ispita",
        exam_term_register_notice2: "dana prije ispitnog roka",
        exam_term_unregister_notice1: "Krajnji vremenski rok za odjavu ispita",
        exam_term_unregister_notice2: "radnih dana prije ispitnog roka",
        exam_succesfully_registered_email_subj: 'Prijava ispita',
        exam_succesfully_registered_email_body: 'Prijavili ste ispit za uslugu "{education}", lokacija: {city}. Datum početka ispita: {date} {term}',
        exam_demo_btn: 'Zatraži demo ispit',
        exam_demo_info: 'Klikom na gumb biti će vam poslani korisnički podaci za pristupanje demo ispitima na MyQTest ispitnom sustavu.',
        exam_demo_success: 'Korisnički podaci su uspješno poslani.',
        exam_demo_error: 'Došlo je do pogreške prilikom slanja email-a. Molimo pokušajte ponovo.',
        no_education_data: "Nema usluga za prijavu ispita.",
        service_select_text: "Dostupne usluge za prijavu ispita",
        show_exams_terms: "Prikaži termine",
        subtitle: "Odaberite i prijavite ispit",
        terms_table: {
            btn_register_exam: "Prijavi ispit"
        },
        terms_table_headers: {
            term_date: "Datum",
            term_time: "Vrijeme",
            classroom: "Učionica",
            address: "Adresa"
        }
    },
    exam_unregister: {
        confirm_button: "Želim odjaviti ispit",
        confirm_cancelation: "Želite li odjaviti ispit {name} u terminu: {date_time}?",
        exam_start: "Pokreni ispit",
        subtitle: "Nisu prikazani termini za koje je istekao minimalni vremenski rok za odjavu",
        terms_table: {
            btn_unregister_exam: "Odjavi ispit"
        },
        terms_table_headers: {
            term_date: "Datum",
            term_time: "Vrijeme",
            education_name: "Usluga",
            address: "Adresa",
            classroom: "Učionica"
        }
    },
    guides: {
        link1: "Vodič za polaznike učionica",
        link2: "Vodič za online polaznike",
        link3: "Vodič za samostalno učenje",
        link4: "Univerzalni zahtjev",
        link5: "Etički kodeks"
    },
    materials_and_docs: {
        subtitle: "Seminarski zadatak i dodatni materijali"
    },
    menu_additional_documents: "Dodatni materijali",
    menu_certificate_claim: "Zahtjev za izdavanje uvjerenja",
    menu_surveys: "Ankete",
    menu_digital_cerficates: "Moja digitalna svjedodžba",
    menu_education_deadline: "Rok za završetak edukacije",
    menu_exam_register: "Prijava ispita",
    menu_exam_unregister: "Odjava i pokretanje ispita",
    menu_education: "Edukacija | EDUKACIJA",
    menu_guides: "Vodiči i zahtjevi",
    menu_my_education: "Edukacija i računi",
    menu_my_schedule: "Moj raspored",
    menu_password_change: "Promjena lozinke",
    menu_presence_exam_results: "Prisutnost i rezultati ispita",
    menu_seminar_task_download: "Preuzimanje materijala",
    menu_seminar_task_upload: "Predaja seminarskog zadatka",
    menu_login: "Prijava",
    my_education: {
        subtitle: "",
        invoice_text: "Računi"
    },
    my_schedule_view: {
        classroom: "Učionica",
        title: "Moj raspored",
        subtitle_table: "Tablični prikaz rasporeda",
        subtitle_calendar: "Kalendarski prikaz rasporeda",
        subtitle_timeline: "Vremenska linija",
        switch_btn_to_calendar: "Prikaži kalendar",
        switch_btn_to_table: "Prikaži tablicu",
        switch_btn_to_timeline: "Prikaži vremensku liniju",
        notification: 'OBAVIJEST!',
        dear_students: 'Poštovani polaznici,',
        new_mob_app: 'nova mobilna aplikacija može se preuzeti na Google ili Apple trgovini mobilnih aplikacija ili na sljedećim poveznicama:',
        table_view_headers: {
            id: "Rbr",
            event_date: "Datum",
            seminar: "Seminar",
            classroom: "Učionica"
        }
    },
    OIB_info: {
        info1: "U bazi nedostaje Vaš OIB.",
        info2: "Kako biste mogli prijaviti i polagati ispite te pregledavati detalje rezultata, potrebno je upisati OIB.",
        info3: "Nakon spremanja OIB-a, moći će te vidjeti termine i prijaviti ispite, a na dan ispita, stranica",
        info4: "za odjavu i pokretanje ispita prikazat će opcije za pokretanje ispita.",
        greska_OIB: "Niste upisali ispravan OIB",
        uspjeh_OIB: "OIB uspješno spremljen"
    },
    page_404: "404 - Stranica nije pronađena",
    page_404_descr: "Stranica kojoj pokušavate pristupiti, ne postoji",
    program_deadline: {
        available_services: "Dostupne usluge",
        extensions: "Produljenja",
        enrolment_expired: "DA | NE",
        subtitle: "",
        table_headers: {
            days: "Dana",
            enrollment_deadline_expiration: "Datum isteka upisa",
            enrollment_expired: "Upis istekao",
            program_duration: "Trajanje programa",
            start_date: "Datum početka"
        },
        table_extension_headers: {
            end_date: "Datum do",
            start_date: "Datum od"
        }
    },
    security_login_dialog: {
        instructions_reset_pass: "Unesite korisničko ime i kliknite pošalji. Resetirana lozinka će Vam stići na email",
        password_forgoten_title: "Zaboravljena lozinka",
        password_forgoten_1: "Ukoliko niste u mogućnosti poništiti lozinku ovim postupkom, kontaktirajte nas na 01/2222-160 ili ",
        password_forgoten_2: "info@algebra.hr",
        password_forgoten_3: "kako bismo Vam resetirali lozinku i ponovno poslali na e-mail adresu.",
        reset: "Pošalji",
        cancel: "Prekid",
        back: "Povratak",
        reports_and_requests_title: "Prijave i zahtjevi",
        reports_and_requests_school_status: "Zahtjev za reguliranje statusa školovanja",
        request_cert: "Zahtjev za izdavanje uvjerenja",
        username_missing: "Morate upisati korisničko ime ili email adresu"
    },
    security: {
        _401_msg: "Nemate pravo pristupa. Isteklo vrijeme prijave, ponovite prijavu",
        _500_msg: "Nemate pravo pristupa. Ponovite prijavu",
        btnSignIn: "PRIJAVA",
        btnSignOut: "ODJAVA",
        login_descr: "Prijava na polaznički portal",
        login_title: "Unesite korisničko ime ili email adresu za prijavu",
        login_error: "Neispravna prijava, provjerite unose",
        password: "Lozinka",
        password_change_descr: "Ispunite sva polja i spremite izmjene",
        password_NEW: "Nova lozinka",
        password_NEW_repeat: "Ponovite novu lozinku",
        password_NEW_repeat_err: "Ponovljena lozinka ne odgovara novoj",
        password_OLD: "Stara lozinka",
        password_noMatch: "Lozinke ne odgovaraju",
        rules: {
            title: "Lozinka mora ispunjavati sljedeće uvjete:",
            password_characters: "Može sadržavati mala i VELIKA slova engleske abecede te brojeve",
            password_characters_rules: "Mora sadržavati barem jedno malo slovo, VELIKO i jedan broj",
            password_length: "Duljina mora biti barem {count} znakova"
        },
        username: "Korisničko ime",
        username_or_email: "Korisničko ime ili email"
    },
    server_msg: {
        account: {
            deactivated: "Vaš korisnički račun je deaktiviran. Molim javite se u Algebru.",
            email_wrong: "Email adresa u sustavu ne postoji.",
            password_changed: "Lozinka uspješno izmijenjena i poslana na e-mail",
            password_change_success: "Lozinka uspješno izmijenjena",
            username_does_not_exist: "Korisničko ime ne postoji",
            email_is_null: "Ne postoji email adresa za ovaj korisnički račun"
        },
        digital_certificates: {
            missing_data: "Svjedodžbu nije moguće izraditi. Nedostaju podaci."
        },
        documents_download: {
            file_does_not_exist: "Datoteka nije pronađena",
            no_defined_seminar_task: "Odabrana usluga nema definiran zadatak"
        },
        ev_lista: {
            present: "Prisutan",
            absent: "Odsutan"
        },
        exam_register: {
            deadline_ended: "Ispit morate prijaviti unutar roka definiranog za završetak programa obrazovanja ili unutar roka produljenja.",
            max_signup: "Ovaj termin je dostigao maksimalan broj prijavljenika. Odaberite drugi termin ispita.",
            missing_date: "Nije odabran datum",
            no_history_id: "Nema usluga za koje možete prijaviti ispit.",
            program_ended: "Za odabrani program je istekao rok",
            term_occupied: "Već imate prijavljen ispit za odabrani termin",
            term_has_expired: "Termin za prijavu ispita mora biti minimalno 20 dana prije termina održavanja ispita"
        },
        exam_unregister: {
            exam_cancelled: "Ispit uspješno odjavljen"
        },
        login: {
            invalid_token: "Greška u prijavi: neispravan token",
            too_many_times: "Pogrešno ste unijeli lozinku previše puta. Vaša lozinka je promijenjena. Molimo, javite se u Algebru kako biste dobili novu lozinku.",
            wrong_pass_or_user: "Neispravno korisničko ime ili lozinka"
        },
        seminar_upload: {
            task_already_exists: "Seminarski zadatak je već poslan",
            upload_email_error: "Rješenje uspješno poslano, ali email obavijest nije poslana"
        }
    },
    validate: {
        required_entry: "Unos je obavezan",
        required_select: "Odabir je obavezan",
    },
    title_attendants_portal: "Polaznički portal",
    validation_noSpaces: "Prazni znakovi nisu dozvoljeni",

    $vuetify: {
        dataTable: {
            rowsPerPageText: "Redaka po str:",
            pageText: "{0}-{1} od {2}"
        },
        dataIterator: {
            rowsPerPageText: "Redaka po str:",
            rowsPerPageAll: "Sve",
            pageText: "{0}-{1} od {2}"
        },
        noDataText: "Nema podataka"
    }
};



// WEBPACK FOOTER //
// ./VueSrc/Common/plugins/translations/hr.js